import Person from './person';

export default class User extends Person {
	constructor(id, name, lastName , email, role, internalIdentifier, dni, category, createdAt, isActive, needsPasswordReset) {
		super(id, name, lastName, email , role, internalIdentifier, dni, category, createdAt, isActive, needsPasswordReset);
	}

	static fromJSON( properties ) {
		return new User(
			properties?.id ?? '',
			properties?.name ?? '',
			properties?.lastName ?? '',
			properties?.email ?? '',
			properties?.role ?? '',
			properties?.internalIdentifier ?? '',
			properties?.dni ?? '',
			properties?.category ?? '',
			properties?.createdAt ?? '',
			properties?.isActive ?? '',
			properties?.needsPasswordReset ?? '',
		);
	}
}
